import React from 'react';
import { IIconProps } from '../IIconProps';

export const ResultIcon = ({ iconClass = '', title = '', pointer }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 24 17"
			className={`${iconClass} ${pointer ? 'icon--pointer' : ''}`}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				d="M0.5 0.5H11.5V8.5H0.5V0.5ZM13.5 0.5H23.5V5.5H13.5V0.5ZM0.5 10.5H11.5V16.5H0.5V10.5ZM13.5 7.5H23.5V16.5H13.5V7.5Z"
				stroke="currentColor"
			/>
		</svg>
	);
};
